import { UserFilterDefaults, UserFilterGroups, UserSearchOptions } from './users-table.filters';

export const UserColumns = [
    {
        displayName: 'User ID',
        sortColumnName: 'id',
        dataType: 'string',
        dataKey: 'id',
        settings: { sort: false, filter: false, multiple: false },
        css: 'w-10',
    },
    {
        displayName: 'First Name',
        sortColumnName: 'firstName',
        dataType: 'string',
        dataKey: 'firstName',
        settings: { sort: true, filter: false, multiple: false },
        css: 'w-20',
    },
    {
        displayName: 'Last Name',
        sortColumnName: 'lastName',
        dataType: 'string',
        dataKey: 'lastName',
        settings: { sort: true, filter: false, multiple: false },
        css: 'w-20',
    },
    {
        displayName: 'Email',
        sortColumnName: 'email',
        dataType: 'string',
        dataKey: 'email',
        settings: { sort: true, filter: false, multiple: false },
        css: 'w-35',
    },
    {
        displayName: 'Last Login',
        sortColumnName: 'lastLogin',
        dataType: 'string',
        dataKey: 'lastLogin',
        settings: { sort: true, filter: false, multiple: false },
        css: 'w-10',
    },
    {
        displayName: 'Actions',
        sortColumnName: 'actions',
        dataType: 'actions',
        dataKey: 'actions',
        settings: { sort: false, filter: false, multiple: false },
        css: 'w-5',
    },
];

export const UserFilters = {
    sorting: {
        sortByColumn: 'firstName',
        sortByDescending: false,
    },

    pagination: {
        paginationEvent: () => {},
        paginationData: {
            pageNumber: 1,
            pageSize: 10,
            total: 10,
        },
        pageSizeOptions: [
            { value: 5, text: '5' },
            { value: 10, text: '10' },
            { value: 25, text: '25' },
            { value: 50, text: '50' },
            { value: 100, text: '100' },
        ],
        defaultPageSize: {
            value: 10,
            text: '10',
        },
    },

    advancedFilters: {
        config: {
            searchOptions: UserSearchOptions,
            filterGroups: UserFilterGroups,
            filterDefaults: UserFilterDefaults,
            defaultSearchOption: UserFilterDefaults.defaultSearchOption,
        },
        callbacks: {
            search: (data) => {},
            filter: (data) => {},
        },
    },
};
